(function(){
  function esc(t){var d=document.createElement("div");d.textContent=t;return d.innerHTML;}
  function build(){
    if(document.querySelector("#ce-compare"))return;
    var q=document.querySelector("#ce-quality")||document.querySelector("#ce-reviews");
    if(!q)return;
    var PIMG=window.CE_PIMG||"";
    var STDIMG="https://cdn.shopify.com/s/files/1/0963/1730/9263/files/hf_20260813_135901_b85578f7-2147-4de7-b6af-9913307a6d8d.png?v=1786629759&width=500";
    var rows=[
      ["Standfestigkeit","Massive Bodenplatte, kippsicher","Oft dünn und wackelig"],
      ["Sisal-Stämme","Dicker Natursisal, fest gewickelt","Dünn, franst schnell aus"],
      ["Für große & schwere Katzen","Ja, bis XXL","Meist nur für kleine Katzen"],
      ["Liegeflächen & Höhle","Mehrere Ebenen, Höhle, Hängematte","Wenig Platz"],
      ["Kauf auf Rechnung (Klarna)","Ja","Selten"],
      ["30 Tage Rückgabe","Ja","Oft nicht"],
      ["Versand","DHL, 2-5 Werktage","Oft lange Lieferzeit"]
    ];
    var ok='<svg class="ce-cmp-ic ce-cmp-ok" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
    var no='<svg class="ce-cmp-ic ce-cmp-no" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var crown='<svg class="ce-cmp-ic ce-cmp-crown" viewBox="0 0 24 24" fill="currentColor"><path d="M5 16L3 6l5 4 4-6 4 6 5-4-2 10z"/></svg>';
    var html='';
    if(PIMG){
      html+='<div class="ce-cmp-cell ce-cmp-hd ce-cmp-corner"><span class="ce-cmp-corner-t">Der Unterschied</span><span class="ce-cmp-corner-d">auf einen Blick</span></div>'
        +'<div class="ce-cmp-cell ce-cmp-hd ce-cmp-us"><span class="ce-cmp-badge">Beste Wahl</span><span class="ce-cmp-hd-name">'+crown+'Cats Empire</span></div>'
        +'<div class="ce-cmp-cell ce-cmp-hd ce-cmp-std">Standard-Baum</div>'
        +'<div class="ce-cmp-cell ce-cmp-imgc ce-cmp-us"><img class="ce-cmp-img" src="'+PIMG+'" alt="Cats Empire Kratzbaum" loading="lazy"></div>'
        +'<div class="ce-cmp-cell ce-cmp-imgc ce-cmp-std"><img class="ce-cmp-img ce-cmp-img-bw" src="'+STDIMG+'" alt="Einfacher Standard-Baum" loading="lazy"></div>';
    } else {
      html+='<div class="ce-cmp-cell ce-cmp-hd ce-cmp-crit"></div>'
        +'<div class="ce-cmp-cell ce-cmp-hd ce-cmp-us"><span class="ce-cmp-badge">Beste Wahl</span><span class="ce-cmp-hd-name">'+crown+'Cats Empire</span></div>'
        +'<div class="ce-cmp-cell ce-cmp-hd ce-cmp-std">Standard-Baum</div>';
    }
    html+=rows.map(function(r){
      return '<div class="ce-cmp-cell ce-cmp-crit">'+esc(r[0])+'</div>'
        +'<div class="ce-cmp-cell ce-cmp-us">'+ok+'<span>'+esc(r[1])+'</span></div>'
        +'<div class="ce-cmp-cell ce-cmp-std">'+no+'<span>'+esc(r[2])+'</span></div>';
    }).join("");
    var sec=document.createElement("section");sec.id="ce-compare";sec.className="ce-compare";
    sec.innerHTML='<h2 class="ce-cmp-h">Cats Empire oder günstiger Standard-Baum?</h2><p class="ce-cmp-sub">Warum sich der Unterschied für dich und deine Katze lohnt.</p><div class="ce-cmp-table">'+html+'</div>';
    q.insertAdjacentElement("afterend",sec);
    var cells=sec.querySelectorAll(".ce-cmp-table>.ce-cmp-cell");
    for(var k=0;k<cells.length;k++){cells[k].style.transitionDelay=(0.05+Math.floor(k/3)*0.05).toFixed(2)+"s";}
    if("IntersectionObserver" in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("ce-in");io.unobserve(e.target);}});},{threshold:0.1});io.observe(sec);}
    setTimeout(function(){sec.classList.add("ce-in");},2600);
  }
  if(document.readyState!=="loading"){build();}else{document.addEventListener("DOMContentLoaded",build);}
  setTimeout(build,1500);
})();